import React, { type FC, useContext } from 'react'
import type { ButtonProps } from '@livechat/design-system-react-components'

import {
  getItemById,
  hasProductInCart,
  isAuthorized,
  isProductLicenseActive,
} from '@/store/selectors'

import { VIEW_MODES } from '@/constants'
import { ViewModeContext } from '@/context/viewMode'
import useParamSelector from '@/hooks/useParamSelector'
import { useTypedSelector } from '@/store/hooks'
import SignInButton from '../Installable/SignIn'
import BuyButton from './BuyButton'
import AddToCartButton from './AddToCart'
import ViewCartButton from './ViewCart'
import TryProductButton from './TryProduct'

interface Props extends ButtonProps {
  id: string
  onlyPrimaryButton?: boolean
}

export const BuyButtonRouter: FC<Props> = (props) => {
  const { id, onlyPrimaryButton } = props

  const viewMode = useContext(ViewModeContext)
  const item = useParamSelector(getItemById, id)
  const isProductActive = useParamSelector(isProductLicenseActive, item.product)
  const isEmbeddedItem = viewMode === VIEW_MODES.EMBEDDED
  const isProductInCart = useParamSelector(hasProductInCart, id)
  const isUserAuthorized = useTypedSelector(isAuthorized)

  switch (true) {
    case !isUserAuthorized:
      return <SignInButton label="Sign in" {...props} />

    case !isProductActive: {
      return <TryProductButton {...props} />
    }

    case isEmbeddedItem:
    case onlyPrimaryButton: {
      return <BuyButton {...props} />
    }

    default:
      return (
        <>
          <BuyButton {...props} />
          {isProductInCart ? (
            <ViewCartButton {...props} />
          ) : (
            <AddToCartButton {...props} />
          )}
        </>
      )
  }
}

export default BuyButtonRouter
